'use client'

import Link from 'next/link'
import { SUPPORT_GMAIL_COMPOSE_URL } from '@/lib/contact'

const MARKETING_ORIGIN = 'https://sigmasense.pk'

export function PortalAppShellFooter() {
  const y = new Date().getFullYear()

  return (
    <footer className="sigma-portal-app-footer" role="contentinfo">
      <div className="sigma-portal-app-footer__inner">
        <div className="sigma-portal-app-footer__brand">
          <Link href="/dashboard" prefetch={false} className="sigma-portal-app-footer__brand-link">
            <span className="sigma-portal-app-footer__name">SigmaSense</span>
          </Link>
        </div>
        <nav className="sigma-portal-app-footer__nav" aria-label="Site links">
          <a
            href={MARKETING_ORIGIN}
            target="_blank"
            rel="noopener noreferrer"
            className="sigma-portal-app-footer__nav-link"
          >
            Marketing site
          </a>
          <Link href="/contact" prefetch={false} className="sigma-portal-app-footer__nav-link">
            Contact
          </Link>
          <Link href="/privacy" prefetch={false} className="sigma-portal-app-footer__nav-link">
            Privacy
          </Link>
          <Link href="/terms" prefetch={false} className="sigma-portal-app-footer__nav-link">
            Terms
          </Link>
          <a
            href={SUPPORT_GMAIL_COMPOSE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="sigma-portal-app-footer__nav-link"
          >
            Support
          </a>
        </nav>
        <p className="sigma-portal-app-footer__legal">© {y} Sigma Sense. All rights reserved.</p>
      </div>
    </footer>
  )
}
